import { Link } from "react-router-dom";
import { useEffect } from "react";
import { ChevronRight, Home } from "lucide-react";

const BREADCRUMB_ID = "dv-breadcrumb-jsonld";

export default function Breadcrumbs({ items }) {
  // items: [{ label, to }] - last item has no `to` (current page)
  useEffect(() => {
    if (typeof document === "undefined" || !items?.length) return;
    const existing = document.getElementById(BREADCRUMB_ID);
    if (existing) existing.remove();

    const origin = typeof window !== "undefined" ? window.location.origin : "";
    const list = [{ label: "Home", to: "/" }, ...items];
    const data = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: list.map((it, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: it.label,
        item: it.to ? `${origin}${it.to}` : undefined,
      })),
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = BREADCRUMB_ID;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(BREADCRUMB_ID);
      if (el) el.remove();
    };
  }, [items]);

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-xs text-slate-500 mb-6 flex-wrap" data-testid="breadcrumbs">
      <Link to="/" className="hover:text-emerald-600 flex items-center gap-1" data-testid="crumb-home">
        <Home className="w-3 h-3" /> Home
      </Link>
      {items?.map((it, i) => (
        <span key={i} className="flex items-center gap-2">
          <ChevronRight className="w-3 h-3 text-slate-300" />
          {it.to ? (
            <Link to={it.to} className="hover:text-emerald-600" data-testid={`crumb-${i}`}>
              {it.label}
            </Link>
          ) : (
            <span className="text-slate-800 font-medium" data-testid={`crumb-current`}>
              {it.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}
